<template>
  <div class="d-flex justify-content-center kid-box">
    <transition
      appear
      v-bind:css="false"
      v-on:before-enter="beforeEnterLanding"
      v-on:enter="enterLanding"
      v-on:leave="leaveLanding"
    >		
			<div class="kid">
				<Notes />
				<div class="hotspots">
					<transition-group
						appear
						v-bind:css="false"
						v-on:before-enter="beforeEnterHotspot"
						v-on:enter="enterHotspot"
						v-if="state.showHotspots"
					>
						<hot-spot v-for="(item, index) in hotspots" :dynamicclass="`hotspot`+item" :key="index" :index="item"></hot-spot>
					</transition-group>
				</div>
			</div>
		</transition>
  </div>
</template>

<script>
import HotSpot from "../particle/HotSpot";
import Notes from '@/components/particle/MusicNotes.vue'

import gsap from 'gsap';
import { inject } from "vue";

export default {
  components: {
		HotSpot,
		Notes
	},
  data () {
		return {
			hotspots: [
				1, 2, 3, 4, 5
			]
		}
	},
  setup() {
    const store = inject("store");
    return {
			actions: store.actions,
			state: store.state
    };
  },
	mounted() {
		// this.$nextTick(() => {
		// 	if(this.showHotspots) this.showStagger = true;
		// });
	},
	computed: {
		staggerItems() {
			return this.hotspots;
		}
	},
  methods: {
    // GSAP transitions
    beforeEnterLanding(el) {
      gsap.set(el, { opacity: 0});
    },
    enterLanding(el, done) {
			console.log(el);
			let that = this;
      gsap.to(el, 0.4, { 
				opacity: 1, 
				onComplete: function(){
					if(that.state.firstVisit) that.actions.toggleIntro(true);
					done();
				} 
			}).delay(0.5);
    },
    leaveLanding(el, done) {
			console.log('leaveLanding');
      gsap.to(el, 0.4, { opacity: 0, onComplete: done });
    },
    beforeEnterHotspot(el) {
      gsap.set(el, { opacity: 0, scale: 0});
    },
    enterHotspot(el, done) {
      gsap.to(el, 0.7, { 
				opacity: 0.8, 
				scale: 1.2,
				ease:'ease.easeOut',
				onComplete: done
			});
      gsap.to(el, 0.7, { 
				opacity: 1, 
				scale: 1,
				ease:'ease.easeIn',
				onComplete: done
			}).delay(0.7);
    },

	}
}
</script>

<style lang="scss">
.kid {
  // width: 326px;
  // height: 538px;
	width: 380px;
	height: 627px;	
  background: url("../../assets/imgs/kid.png") no-repeat;
  background-size: contain;
  margin-right: 50px;
  position: relative;
}
.kid-box {
  padding-top: 11%;
}
@media (max-width: 414px) {
  .kid-box {
    padding-top: 30%;
  }
  .kid {
    width: 380px;
    height: 627px;
    margin-right: 0px;
  }
}
</style>
